import { SUBSCRIPTION_TYPES } from './subscriptions';

/**
 * Checkout preview of campaign discounts, keyed by campaign id (`promoSeries`).
 * Must mirror `SelfServePromotion` in hgpro-selfserve-app Lambda appsettings.json:
 * the Lambda applies the actual Stripe promotion code; this table only drives display.
 */
export const SELF_SERVE_CAMPAIGN_PROMOTIONS = Object.freeze({
  'elevated-50-off': {
    percentOff: 50,
    promotionCodes: {
      [SUBSCRIPTION_TYPES.MONTHLY.planCode.provider]: 'PROVIDER-MONTHLY-50-OFF',
      [SUBSCRIPTION_TYPES.ANNUAL.planCode.provider]: 'PROVIDER-ANNUAL-50-OFF',
      [SUBSCRIPTION_TYPES.MONTHLY.planCode.admin]: 'ROSTER-MONTHLY-50-OFF',
      [SUBSCRIPTION_TYPES.ANNUAL.planCode.admin]: 'ROSTER-ANNUAL-50-OFF',
    },
  },
});
